/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {JSONable} from '@irian-ro/abstract-resource';
import {MasterRoutingSolutionSegmentWithSelectedRS} from "./master-routing-solution-segment-with-selected-rs.model";
import {CurrencyValueModel} from "./currency-value.model";
import { MasterRoutingSolutionState } from './master-routing-solution/master-routing-solution-state.model';

export class MasterRoutingSolutionExtended extends JSONable {

  uuid: string | undefined = undefined;
  shipmentGroupUuid: string | undefined = undefined;
  solutionSegmentViewSet: MasterRoutingSolutionSegmentWithSelectedRS[] | undefined = undefined;
  totalCost: CurrencyValueModel | undefined = undefined;
  state: MasterRoutingSolutionState | undefined = undefined;
}
